import React from 'react'
import { UserEditFormAdminStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'
import { EMAIL_REGEX } from 'helpers'
import { toast } from 'react-toastify'
import { store } from 'store'
import { usermanageController } from '../../apiService'
import { toastActive } from '../../helpers/functions/toastSuccess'
import { toastFail } from '../../helpers/functions/toastFail'

export class UserEditFormAdminContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      optionsRole: [{ value: 1, label: 'Admin' }],
      isActive: true,
      optionsRoleValue: null,
      isEditPageState: false,
      status: '',
      is_active: 0,
      name: '',
      email: '',
      full_name: '',
      Phone: '',
      nameValid: true,
      emailValid: true,
      phoneValid: false,
      roleValid: false,
      role: '',
      lockSave: false,
      formValid: true,
      BuyerList: [],
      id: '',
      toastActive: false,
      submitted: true,
      clickResendmail: false,
      acountStatus: null,
      disabledToggle: false,
    }
  }
  componentDidMount() {
    let url = window.location.pathname
    let id = url.substring(url.lastIndexOf(':') + 1)
    this.setState({ id: id })
    this._fetchgetAdminID(id)
  }

  _fetchgetAdminID(id) {
    this.setState({ AdminListLoading: true })
    return usermanageController()
      .getAdmin(id)
      .then(
        res => {
          this.mapState(res)
        }
        // this.setState({ BuyerList: res.records, BuyerListLoading: false })
      )
      .finally(() => this.setState({ AdminListLoading: false }))
  }

  mapState = response => {
    const res =
      response && (response.full_name != null || response.email != null)
        ? response
        : response && response.result && typeof response.result === 'object'
        ? response.result
        : response || {}
    const fullName = res.full_name || ''
    const email = res.email || ''
    const phone = res.Phone || res.phone || ''
    const role = parseInt(res.role_id != null ? res.role_id : res.role, 10)

    this.setState({
      BuyerList: res,
      full_name: fullName,
      email,
      Phone: phone,
      role,
      acountStatus: res.status,
      isActive: res.status === 1,
      nameValid: fullName.length !== 0,
      emailValid: RegExp(EMAIL_REGEX).test(email),
      phoneValid: phone.length !== 0,
    })
    const waitActive = res.status === 2
    const inactive = res.status === 0
    if (inactive) {
      this.setState({
        disabledToggle: true,
      })
    }
    if (waitActive) {
      this.setState({
        clickResendmail: true,
        is_active: false,
        disabledToggle: true,
      })
    }
  }

  handleUserInput = e => {
    const { name, value } = e.target
    if (name === 'email') this.setState({ lockSave: true })
    this.setState({ [name]: value }, () => {
      this.validateField(name, (value || '').trim())
    })
  }

  handleUserDropdown = optionsRole => {
    this.setState({ role: optionsRole.value }, () => {
      this.validateField(optionsRole.label, optionsRole.value)
    })
  }

  handleChange = e => {
    if (this.state.clickResendmail) return
    this.setState(prevState => ({
      isActive: !prevState.isActive,
      acountStatus: !prevState.isActive ? 1 : 0,
    }))
  }

  validateField = (fieldName, value) => {
    // console.log('xxxx ', fieldName, '  sss ', value)

    let nameValid = this.state.full_name
    let emailValid = this.state.email
    let phoneValid = this.state.phoneValid

    switch (fieldName) {
      case 'full_name':
        nameValid = value.length !== 0
        this.setState({ nameValid: nameValid })
        break
      case 'email':
        emailValid = RegExp(EMAIL_REGEX).test(value)
        //console.log('emailValid', emailValid)
        this.setState({ emailValid: emailValid })
        break
      case 'Phone':
        phoneValid = value.length !== 0
        this.setState({ phoneValid: phoneValid })
        break
      default:
        break
    }
  }

  onFormSubmit = e => {
    const active = 1
    const inActive = 0
    let data = {
      admin_id: parseInt(this.state.id),
      // email: this.state.email,
      full_name: this.state.full_name,
      Phone: this.state.Phone,
      role: parseInt(this.state.role),
      status: this.state.acountStatus,
    }

    // e.preventDefault()
    if (
      this.state.nameValid &&
      this.state.emailValid &&
      this.state.Phone !== ''
    ) {
      this.setState(
        {
          formValid: true,
        },
        () =>
          usermanageController()
            .updateAdmin(data)
            .then(res => {
              setTimeout(() => {
                toastActive(res.message)
                this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK)
              }, 500)
              console.log('respone!!!!!!!!!!!!!!!!!!!!!!!!', res)
            })
            .finally(
              () => this.setState({ BuyerListLoading: false })
              // this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK)
            )
      )
    }
  }

  onFormSubmitEmail = e => {
    let data = {
      admin_id: parseInt(this.state.id),
      email: this.state.email,
      // full_name: this.state.full_name,
      // Phone: this.state.Phone,
      // emp_ref_id: this.state.emp_ref_id,
      // role: parseInt(this.state.role),
    }

    e.preventDefault()
    if (this.state.nameValid && this.state.emailValid) {
      this.setState(
        {
          submitted: false,
          formValid: true,
        },
        () =>
          usermanageController()
            .updateEmailAdmin(data)
            .then(res => {
              if (res) {
                this._fetchgetAdminID(this.state.id)
                if (res.status === 'EmailDuplicate') {
                  this.setState({
                    submitted: true,
                  })
                  toastFail('Email duplicate please change email')
                } else if (res.status === 'UpdateSuccess') {
                  this.setState({
                    submitted: true,
                    clickResendmail: true,
                    isActive: false,
                    acountStatus: 2,
                  })
                  toastActive('Resend Activation Email')
                }
              }
            })
            .finally(
              () =>
                // this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK)
                this.setState({ lockSave: false })
              //setTimeout(() => this._fetchgetUser(), 500)
            )
      )
    } else {
      this.setState({
        formValid: false,
      })
    }
  }

  render() {
    const { optionsRole, isActive } = this.state

    return (
      <UserEditFormAdminStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_user_form"
                src={ICONS['icon-user-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_user_form" className="title">
                User Management
              </Section>

              <Section id="page_breadcrumb_user_form" className="breadcrumbs">
                <Button
                  className="breadcrumb"
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  onClick={() => {
                    this.props.history.push(
                      ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK
                    )
                  }}
                  className="breadcrumb"
                >
                  <span>User Management</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>Edit User</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">Edit User</Section>

              <Section
                className={
                  'form-group' +
                  (this.state.full_name === '' ? ' is-error' : '')
                }
              >
                <label>Full Name</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="fullname"
                      className={this.state.full_name === '' ? ' is-error' : ''}
                      type="text"
                      name="full_name"
                      value={(this.state.full_name || '').trim()}
                      onChange={this.handleUserInput}
                    />
                  </Section>

                  <Section className="message">
                    {this.state.full_name === '' ? STRING.INVALID : ''}
                  </Section>
                </Section>
              </Section>

              <Section
                className={
                  'form-group' +
                  (this.state.emailValid
                    ? ''
                    : this.state.formValid
                    ? ''
                    : ' is-error')
                }
              >
                <label>Email</label>

                <Section className="form-group-control with-button">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="email"
                      className={
                        this.state.emailValid
                          ? ''
                          : this.state.formValid
                          ? ''
                          : 'is-error'
                      }
                      type="text"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleUserInput}
                    />

                    <Button
                      className="theme-blue resend-activation-email"
                      disabled={this.state.lockSave === false ? true : false}
                      onClick={
                        this.state.lockSave === false
                          ? null
                          : this.onFormSubmitEmail
                      }
                    >
                      {this.state.submitted ? (
                        'Resend Activation Email'
                      ) : (
                        <span className="loader"></span>
                      )}
                    </Button>
                  </Section>

                  {this.state.email === '' && (
                    <Section className="message">{STRING.INVALID}</Section>
                  )}
                  {!this.state.emailValid && this.state.email !== '' && (
                    <Section className="message">
                      {STRING.EMAIL_INVALID}
                    </Section>
                  )}

                  {this.state.emailValid && this.state.email !== '' && (
                    <Section className="message">{''}</Section>
                  )}
                </Section>
              </Section>

              <Section
                className={
                  'form-group' + (this.state.Phone === '' ? ' is-error' : '')
                }
              >
                <label>Phone</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="Phone"
                      className={
                        'form-group' +
                        (!this.state.phoneValid
                          ? ''
                          : this.state.formValid
                          ? ''
                          : ' is-error')
                      }
                      type="text"
                      name="Phone"
                      value={(this.state.Phone || '').trim()}
                      onChange={this.handleUserInput}
                    />
                  </Section>

                  <Section className="message">
                    {this.state.Phone === '' ? STRING.INVALID : ''}
                  </Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Role</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <SelectBox
                      id="active_status_filter"
                      options={optionsRole}
                      onChange={this.handleUserDropdown}
                      value={this.state.optionsRole.find(
                        e => e.value == this.state.role
                      )}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Active</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Switcher
                      onChange={() => this.handleChange(isActive)}
                      checked={isActive}
                    />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-actions">
              <Button
                className="theme-border-gray"
                onClick={() => {
                  this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK)
                }}
              >
                Cancel
              </Button>

              <Button
                className="theme-green"
                onClick={() => {
                  this.state.lockSave === true
                    ? toastFail('Please Resend Activation Email')
                    : this.onFormSubmit()
                }}
                disabled={this.state.lockSave}
              >
                Save
              </Button>
            </Section>
          </Section>
        </Section>
      </UserEditFormAdminStyle>
    )
  }
}
